import { FloatingLabelInput, FloatingLabelSelect, FloatingLabelTextarea, FormButton } from '../../components.js';
import { EditPage, populateEditForm } from '../crud/shared.js';

export class BrandsEdit extends EditPage {
  static statusOptions = [
    { value: 'active', label: 'Active' },
    { value: 'archived', label: 'Archived' }
  ];

  static timlComponents = {
    ...EditPage.timlComponents,
    FloatingLabelSelect,
    FormButton
  };

  static get formAction() {
    return API.resourceUrl('brands', Routing.params.id);
  }

  static timl = `
    <Breadcrumbs title="Brands" href="/brands" nameHref="/brands/{{ Routing.params.id }}" nameStyle="" nameSeparatorStyle="" suffix="Edit" suffixStyle="" suffixSeparatorStyle="">

    form.fade.stacked-form[method="PATCH" action="{{ Routing.routeObject.formAction }}" onSuccessRedirect="/brands"]
      <FloatingLabelInput label="Name" name="name">
      <FloatingLabelInput label="Slug (optional)" name="slug" required="false">
      <FloatingLabelInput label="Domain (optional)" name="domain" required="false">
      <FloatingLabelTextarea label="Description (optional)" name="description" required="false">
      <FloatingLabelInput label="Logo URL (optional)" name="logoUrl" required="false">
      <FloatingLabelInput label="Primary Color (optional)" name="primaryColor" required="false">
      <FloatingLabelInput label="Support Email (optional)" name="supportEmail" required="false">
      <FloatingLabelSelect label="Status" name="status" options="{{ Routing.routeObject.statusOptions }}">
      .horizontal-flex.mt-15
        <FormButton label="Update">
        a.underline.pointer.ml-auto.red.f12[href="/{{ Routing.getRouteFromPathName() }}/{{ Routing.params.id }}/delete"] Delete
  `;

  static javascript() {
    API.get(API.resourceUrl('brands', Routing.params.id))
      .then(data => {
        populateEditForm(data.data);
        document.querySelector('#name').innerHTML = data.data.name;
        document.querySelector('.fade:not(.in)').classList.add('in');
      });
  }
}
